import React, { useCallback, useState } from 'react';
import styled from 'styled-components';

import SearchBar from 'components/searchBar/SearchBar';
import { STANDARD_PAGE_SIZE } from 'components/table/models';

import ManageTable from './ManageTable';
import manageUserMockData from './manageUserMockData';

type ManageProps = {
  chooseActiveItem: (i: number) => void;
  activeNavigationItem: string;
};

const Manage = ({ chooseActiveItem, activeNavigationItem }: ManageProps) => {
  const [isCreatingModalOpen, setIsCreatingModalOpen] = useState(false);
  const [sortByListItemIndex, setSortByListItemIndex] = useState(1);
  const [pageSize, setPageSize] = useState(STANDARD_PAGE_SIZE);
  const [nameForSearching, setNameForSearching] = useState('');

  const toggleCreatingModalWindow = useCallback(() => {
    setIsCreatingModalOpen(!isCreatingModalOpen);
  }, [isCreatingModalOpen]);

  return (
    <Container>
      <SearchBar
        isEmployerPage
        isHiddenButton
        title="ARNOLD CLARK"
        buttonText="Create account"
        nameToFilter={nameForSearching}
        openModalWindow={toggleCreatingModalWindow}
        activeFilterParameter={nameForSearching}
        setNewNameToFilter={setNameForSearching}
      />
      <ManageTable
        activeNavigationItem={activeNavigationItem}
        chooseActiveItem={chooseActiveItem}
        sortByListItemIndex={sortByListItemIndex}
        sortUsers={setSortByListItemIndex}
        data={manageUserMockData}
        pageSize={pageSize}
        changePageSize={setPageSize}
        dataAmount={manageUserMockData.length}
      />
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  max-width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.lightYellow};
  box-sizing: border-box;
`;

export default Manage;
